export default ".lib-alert-window {\n  max-width: $w$px;\n  max-height: $h$px;\n}\n";